import React from 'react';

export const ComponentDebugModule = () => {
  return <div>Test components</div>;
};
